import { render, staticRenderFns } from "./InsCmsList.vue?vue&type=template&id=38682824&scoped=true&"
import script from "./InsCmsList.vue?vue&type=script&lang=ts&"
export * from "./InsCmsList.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsList.vue?vue&type=style&index=0&id=38682824&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38682824",
  null
  
)

export default component.exports